import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

export const defaultState = {
  payout: {
    creation: {
      types: {},
    },
    approval: {
      pending: [],
      pendingLoading: false,
    },
    holderEnrichment: {
      pending: [],
      pendingLoading: false,
    },
    holderApproval: {
      pending: [],
      pendingLoading: false,
    },
    bankTransferApproval: {
      pending: [],
      pendingLoading: false,
    },
    finalCheckApproval: {
      pending: [],
      pendingLoading: false,
      processed: [],
      processedLoading: false,
    },
    failedJob: {
      open: [],
      openLoading: false,
      resolved: [],
      resolvedLoading: false,
    },
  },
};

export const mutations = {
  // Payout Creation
  PAYOUT_CREATION_SET_TYPES(state, types) {
    state.payout.creation.types = types;
  },
  // Payout Approval
  PAYOUT_APPROVAL_SET_PENDING(state, pending) {
    state.payout.approval.pending = pending;
  },
  PAYOUT_APPROVAL_SET_PENDING_LOADING(state, isLoading) {
    state.payout.approval.pendingLoading = isLoading;
  },
  // Holder Enrichment
  PAYOUT_HOLDER_ENRICHMENT_SET_PENDING(state, pending) {
    state.payout.holderEnrichment.pending = pending;
  },
  PAYOUT_HOLDER_ENRICHMENT_SET_PENDING_LOADING(state, isLoading) {
    state.payout.holderEnrichment.pendingLoading = isLoading;
  },
  // Holder Approval
  PAYOUT_HOLDER_APPROVAL_SET_PENDING(state, pending) {
    state.payout.holderApproval.pending = pending;
  },
  PAYOUT_HOLDER_APPROVAL_SET_PENDING_LOADING(state, isLoading) {
    state.payout.holderApproval.pendingLoading = isLoading;
  },
  // Bank Transfer Approval
  PAYOUT_BANK_TRANSFER_APPROVAL_SET_PENDING(state, pending) {
    state.payout.bankTransferApproval.pending = pending;
  },
  PAYOUT_BANK_TRANSFER_APPROVAL_SET_PENDING_LOADING(state, isLoading) {
    state.payout.bankTransferApproval.pendingLoading = isLoading;
  },
  // Final Transfer Approval
  PAYOUT_FINAL_CHECK_APPROVAL_SET_PENDING(state, pending) {
    state.payout.finalCheckApproval.pending = pending;
  },
  PAYOUT_FINAL_CHECK_APPROVAL_SET_PENDING_LOADING(state, isLoading) {
    state.payout.finalCheckApproval.pendingLoading = isLoading;
  },
  PAYOUT_FINAL_CHECK_APPROVAL_SET_PROCESSED(state, processed) {
    state.payout.finalCheckApproval.processed = processed;
  },
  PAYOUT_FINAL_CHECK_APPROVAL_SET_PROCESSED_LOADING(state, isLoading) {
    state.payout.finalCheckApproval.processedLoading = isLoading;
  },
  // Failed Job
  PAYOUT_FAILED_JOB_SET_OPEN(state, open) {
    state.payout.failedJob.open = open;
  },
  PAYOUT_FAILED_JOB_SET_OPEN_LOADING(state, isLoading) {
    state.payout.failedJob.openLoading = isLoading;
  },
  PAYOUT_FAILED_JOB_SET_RESOLVED(state, resolved) {
    state.payout.failedJob.resolved = resolved;
  },
  PAYOUT_FAILED_JOB_SET_RESOLVED_LOADING(state, isLoading) {
    state.payout.failedJob.resolvedLoading = isLoading;
  },
};

export const getters = {
  // Payout Creation
  getPayoutsCreationTypes: state => state.payout.creation.types,
  // Payout Approval
  getPayoutsApprovalPending: state => state.payout.approval.pending,
  getPayoutsApprovalPendingIsLoading: state => state.payout.approval.pendingLoading,
  // Holder Enrichment
  getPayoutsHolderEnrichmentPending: state => state.payout.holderEnrichment.pending,
  getPayoutsHolderEnrichmentPendingIsLoading: state => state.payout.holderEnrichment.pendingLoading,
  // Holder Approval
  getPayoutsHolderApprovalPending: state => state.payout.holderApproval.pending,
  getPayoutsHolderApprovalPendingIsLoading: state => state.payout.holderApproval.pendingLoading,
  // Bank Transfer Approval
  getPayoutsBankTransferApprovalPending: state => state.payout.bankTransferApproval.pending,
  // eslint-disable-next-line max-len
  getPayoutsBankTransferApprovalPendingIsLoading: state => state.payout.bankTransferApproval.pendingLoading,
  // Final Check Approval
  getPayoutsFinalCheckApprovalPending: state => state.payout.finalCheckApproval.pending,
  // eslint-disable-next-line max-len
  getPayoutsFinalCheckApprovalPendingIsLoading: state => state.payout.finalCheckApproval.pendingLoading,
  getPayoutsFinalCheckApprovalProcessed: state => state.payout.finalCheckApproval.processed,
  // eslint-disable-next-line max-len
  getPayoutsFinalCheckApprovalProcessedIsLoading: state => state.payout.finalCheckApproval.processedLoading,
  // Failed Job
  getPayoutsFailedJobOpen: state => state.payout.failedJob.open,
  getPayoutsFailedJobOpenIsLoading: state => state.payout.failedJob.openLoading,
  getPayoutsFailedJobResolved: state => state.payout.failedJob.resolved,
  getPayoutsFailedJobResolvedIsLoading: state => state.payout.failedJob.resolvedLoading,
};

const getList = (state, type) => {
  if (type === 'approval') {
    return state.payout.approval.pending;
  }

  if (type === 'holderEnrichment') {
    return state.payout.holderEnrichment.pending;
  }

  if (type === 'holderApproval') {
    return state.payout.holderApproval.pending;
  }

  if (type === 'bankTransferApproval') {
    return state.payout.bankTransferApproval.pending;
  }

  if (type === 'finalCheckApproval') {
    return state.payout.finalCheckApproval.pending;
  }

  if (type === 'approvedPayouts') {
    return state.payout.finalCheckApproval.processed;
  }

  return null;
};

const getTypeName = (type) => {
  if (type === 'approval') {
    return 'PAYOUT_APPROVAL_SET_PENDING';
  }

  if (type === 'holderEnrichment') {
    return 'PAYOUT_HOLDER_ENRICHMENT_SET_PENDING';
  }

  if (type === 'holderApproval') {
    return 'PAYOUT_HOLDER_APPROVAL_SET_PENDING';
  }

  if (type === 'bankTransferApproval') {
    return 'PAYOUT_BANK_TRANSFER_APPROVAL_SET_PENDING';
  }

  if (type === 'finalCheckApproval') {
    return 'PAYOUT_FINAL_CHECK_APPROVAL_SET_PENDING';
  }

  if (type === 'approvedPayouts') {
    return 'PAYOUT_FINAL_CHECK_APPROVAL_SET_PROCESSED';
  }

  return null;
};

export const actions = {
  // Payout Data
  fetchPayoutDataGetHolders({ state, commit }, { origin, payoutId }) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/data/${payoutId}/holders`)
      .then(({ data }) => downloadFromS3(data).then((response) => {
        data = response;
        if (origin) {
          const result = getList(state, origin).filter(payout => payout.payout_id === payoutId);

          if (result.length !== 0) {
            result[0].holders = data.holders;
          }

          commit(getTypeName(origin), getList(state, origin));
        }

        return data;
      }))
      .catch(error => Promise.reject(error));
  },
  // Payout Creation
  fetchPayoutCreationTypes({ commit }) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/creation/types`)
      .then(({ data }) => {
        commit('PAYOUT_CREATION_SET_TYPES', data);

        return data.data;
      })
      .catch((error) => {
        commit('PAYOUT_CREATION_SET_TYPES', {});

        return Promise.reject(error);
      });
  },
  createPayout({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/creation/store/`, payload)
      .then((data) => {
        dispatch('fetchPayoutApprovalPending');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  updatePayout({ dispatch }, payload) {
    const payoutId = payload.payout_id;

    return axios.put(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/creation/update/${payoutId}`, payload)
      .then((data) => {
        dispatch('fetchPayoutApprovalPending');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  // Payout Approval
  fetchPayoutApprovalPending({ commit }, filterByType) {
    commit('PAYOUT_APPROVAL_SET_PENDING_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/approval/pending?filter_by_type=${filterByType}`, {
      filter_by_type: filterByType,
    })
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { payouts } = response;
          commit('PAYOUT_APPROVAL_SET_PENDING_LOADING', false);
          commit('PAYOUT_APPROVAL_SET_PENDING', payouts);
        });
      })
      .catch((error) => {
        commit('PAYOUT_APPROVAL_SET_PENDING_LOADING', false);
        commit('PAYOUT_APPROVAL_SET_PENDING', []);

        return Promise.reject(error);
      });
  },
  callPayoutApprovalApprove({ dispatch }, payoutId) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/approval/approve`, {
      payout_id: payoutId,
      approved: true,
    }, {
    })
      .then(() => {
        dispatch('fetchPayoutAll');
      });
  },
  callPayoutDelete({ dispatch }, payoutId) {
    return axios.delete(`${window.BASE_API.PAYOUT_AND_TAXES}/payout`, {
      data: {
        payout_id: payoutId,
      },
    }, {
    })
      .then(() => {
        dispatch('fetchPayoutAll');
      });
  },
  callPayoutStartInterestCalculation(event, payoutId) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/startInterestCalculation`, {
      payout_id: payoutId,
    }, {
    });
  },
  // Holder Enrichment
  fetchPayoutHolderEnrichmentPending({ commit }, filterByType) {
    commit('PAYOUT_HOLDER_ENRICHMENT_SET_PENDING_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/holder-enrichment/pending?filter_by_type=${filterByType}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { payouts } = response;
          commit('PAYOUT_HOLDER_ENRICHMENT_SET_PENDING', payouts);
          commit('PAYOUT_HOLDER_ENRICHMENT_SET_PENDING_LOADING', false);
        });
      })
      .catch((error) => {
        commit('PAYOUT_HOLDER_ENRICHMENT_SET_PENDING', []);
        commit('PAYOUT_HOLDER_ENRICHMENT_SET_PENDING_LOADING', false);

        return Promise.reject(error);
      });
  },
  // eslint-disable-next-line no-unused-vars
  callPayoutHolderEnrichmentImportCSV({ dispatch }, params) {
    const formData = new FormData();
    formData.append('file', params.file);
    formData.append('payout_id', params.payoutId);

    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/holder-enrichment/import/csv`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(result => result.data);
  },
  // eslint-disable-next-line no-unused-vars
  callPayoutImportCSV({ dispatch }, params) {
    const formData = new FormData();
    formData.append('file', params.file);

    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/creation/import/csv`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(result => result.data);
  },
  // eslint-disable-next-line no-unused-vars
  callPayoutImportGlobalCSV({ dispatch }, params) {
    const formData = new FormData();
    formData.append('file', params.file);

    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/holder-enrichment/import/global/csv`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(result => result.data);
  },
  // eslint-disable-next-line no-unused-vars
  callPayoutTaxCalculationImportCSV({ dispatch }, params) {
    const formData = new FormData();
    formData.append('file', params.file);
    formData.append('payout_id', params.payoutId);

    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/tax-calculation/import/csv`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(result => result.data);
  },
  // Holder Approval
  fetchPayoutHolderApprovalPending({ commit }, filterByType) {
    commit('PAYOUT_HOLDER_APPROVAL_SET_PENDING_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/holder-approval/pending?filter_by_type=${filterByType}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { payouts } = response;
          commit('PAYOUT_HOLDER_APPROVAL_SET_PENDING_LOADING', false);
          commit('PAYOUT_HOLDER_APPROVAL_SET_PENDING', payouts);
        });
      })
      .catch((error) => {
        commit('PAYOUT_HOLDER_APPROVAL_SET_PENDING_LOADING', false);
        commit('PAYOUT_HOLDER_APPROVAL_SET_PENDING', []);

        return Promise.reject(error);
      });
  },
  callPayoutHolderEnrichmentApproval({ dispatch }, payoutId) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/holder-enrichment/approve`, {
      payout_id: payoutId,
      approved: true,
    })
      .then(() => {
        dispatch('fetchPayoutAll');
      });
  },
  callPayoutHolderApproval({ dispatch }, params) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/holder-approval/approve`, {
      payout_id: params.payoutId,
      approved: params.approve,
    })
      .then(() => {
        dispatch('fetchPayoutAll');
      });
  },
  // eslint-disable-next-line no-unused-vars
  fetchPayoutHolderApprovalDownloadCsv({ commit }, payoutId) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/holder-approval/export/csv/${payoutId}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
  // eslint-disable-next-line no-unused-vars
  fetchPayoutApprovalDownloadCsv({ commit }, payoutId) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/approval/export/csv/${payoutId}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
  // Bank Transfer Approval
  fetchPayoutBankTransferApprovalPending({ commit }, filterByType) {
    commit('PAYOUT_BANK_TRANSFER_APPROVAL_SET_PENDING_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/bank-transfer-approval/pending?filter_by_type=${filterByType}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { payouts } = response;
          commit('PAYOUT_BANK_TRANSFER_APPROVAL_SET_PENDING_LOADING', false);
          commit('PAYOUT_BANK_TRANSFER_APPROVAL_SET_PENDING', payouts);
        });
      })
      .catch((error) => {
        commit('PAYOUT_BANK_TRANSFER_APPROVAL_SET_PENDING_LOADING', false);
        commit('PAYOUT_BANK_TRANSFER_APPROVAL_SET_PENDING', []);

        return Promise.reject(error);
      });
  },
  callPayoutBankTransferApprovalApprove({ dispatch }, payoutId) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/bank-transfer-approval/approve`, {
      payout_id: payoutId,
      approved: true,
    })
      .then(() => {
        dispatch('fetchPayoutAll');
      });
  },
  // eslint-disable-next-line no-unused-vars
  fetchPayoutBankTransferDownloadCsv({ commit }, payoutId) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/bank-transfer-approval/export/csv/${payoutId}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
  fetchPayoutInvestorBankTransferDownloadCsv({ commit }, payoutId) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/creation/holder-bank-transfer/export/csv/${payoutId}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
  fetchPayoutChurchTaxDownloadCsv({ commit }, payoutId) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/creation/church-tax/export/csv/${payoutId}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
  fetchPayoutChurchTaxCashbackV2DownloadCsv({ commit }, params) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/creation/church-tax-cashback-v2/export/csv/1`, { params })
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
  // Final Check Approval
  fetchPayoutFinalCheckApprovalPending({ commit }, filterByType) {
    commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PENDING_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/final-check-approval/pending?filter_by_type=${filterByType}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { payouts } = response;
          commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PENDING_LOADING', false);
          commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PENDING', payouts);
        });
      })
      .catch((error) => {
        commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PENDING_LOADING', false);
        commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PENDING', []);

        return Promise.reject(error);
      });
  },
  fetchPayoutFinalCheckApprovalProcessed({ commit }, types) {
    commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PROCESSED_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/final-check-approval/processed?types=${types}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { payouts } = response;
          commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PROCESSED_LOADING', false);
          commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PROCESSED', payouts);
        });
      })
      .catch((error) => {
        commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PROCESSED_LOADING', false);
        commit('PAYOUT_FINAL_CHECK_APPROVAL_SET_PROCESSED', []);

        return Promise.reject(error);
      });
  },
  callPayoutFinalCheckApprovalApprove({ dispatch }, params) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/final-check-approval/approve`, {
      payout_id: params.payoutId,
      approved: params.approve,
    })
      .then(() => {
        dispatch('fetchPayoutAll');
      });
  },
  // eslint-disable-next-line no-unused-vars
  callLoanPayoutEmail({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/mail/loan`, {
      payout_ids: data.payout_ids,
      subject: data.subject,
      dynamic_text: data.dynamic_text,
      test_mode: data.test_mode || false,
      trustpilot_enabled: typeof data.trustpilot_enabled === 'boolean' ? data.trustpilot_enabled : true,
    });
  },
  // eslint-disable-next-line no-unused-vars
  callYieldPayoutEmail({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/mail/yield`, {
      payout_ids: data.payout_ids,
      subject: data.subject,
      dynamic_text: data.dynamic_text,
      test_mode: data.test_mode || false,
      trustpilot_enabled: typeof data.trustpilot_enabled === 'boolean' ? data.trustpilot_enabled : true,
    });
  },
  // eslint-disable-next-line no-unused-vars
  callBaaderPayoutEmail({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/mail/baader`, {
      payout_ids: data.payout_ids,
      subject: data.subject,
      dynamic_text: data.dynamic_text,
      test_mode: data.test_mode || false,
      trustpilot_enabled: typeof data.trustpilot_enabled === 'boolean' ? data.trustpilot_enabled : true,
    });
  },
  // eslint-disable-next-line no-unused-vars
  fetchPayoutsFinalApprovedAndSecurityId({ state, commit }, securityId) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/final-check-approval/approved/security/${securityId}`)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },
  // eslint-disable-next-line no-unused-vars
  fetchPayoutsFinalApproveAndExpectedPayoutDateYield({ state, commit }, expectedPayoutDate) {
    return axios.get(
      `${window.BASE_API.PAYOUT_AND_TAXES}/payout/final-check-approval/expected-payout-date/${expectedPayoutDate}?security_type=yield_token`,
    ).then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },
  // eslint-disable-next-line no-unused-vars
  fetchPayoutsFinalApproveAndExpectedPayoutDateBaader({ state, commit }, expectedPayoutDate) {
    return axios.get(
      `${window.BASE_API.PAYOUT_AND_TAXES}/payout/final-check-approval/expected-payout-date/${expectedPayoutDate}?security_type=yield_baader`,
    ).then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },
  // eslint-disable-next-line no-unused-vars
  callRetryEvent({ dispatch }, requestData) {
    const { holder, eventName } = requestData;

    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/replay`, {
      payout_id: holder.payout_id,
      holder_id: holder.id,
      event_name: eventName,
    });
  },
  callAllMissingTaxCalculation({ dispatch }, payoutId) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/replay`, {
      payout_id: payoutId,
      event_name: 'tax-calculation-retry',
    })
      .then(() => {
        dispatch('fetchPayoutAll');
      });
  },
  callAllMissingAddressDataEnrichment({ dispatch }, payoutId) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/replay`, {
      payout_id: payoutId,
      event_name: 'address-enrichment-retry',
    })
      .then(() => {
        dispatch('fetchPayoutAll');
      });
  },
  callAllBankInformationEnrichment({ dispatch }, payoutId) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/payout/replay`, {
      payout_id: payoutId,
      event_name: 'bank-information-enrichment-retry',
    })
      .then(() => {
        dispatch('fetchPayoutAll');
      });
  },
  callDeleteHolder({ dispatch }, requestData) {
    return axios.delete(`${window.BASE_API.PAYOUT_AND_TAXES}/holder`, {
      data: requestData,
    }, {}).then(() => {
      dispatch('fetchPayoutAll');
    });
  },
  // PDF Service
  // eslint-disable-next-line no-unused-vars
  fetchPayoutPdfServiceDownloadPdf({ commit }, requestData) {
    const { payoutId, holderId, holderType } = requestData;

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/pdf/download/${payoutId}/${holderId}/${holderType}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
  // Tax Reports Service
  // eslint-disable-next-line no-unused-vars
  fetchPayoutTaxReportsDocumentsByUserId({ commit }, userId) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-reports/admin/${userId}`)
      .then(({ data }) => (data))
      .catch(error => Promise.reject(error));
  },
  // eslint-disable-next-line no-unused-vars
  fetchPayoutTaxReportsDownloadDocumentByUserIdAndFileName({ commit }, requestData) {
    const { userId, fileName } = requestData;

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-reports/admin/${userId}/${fileName}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
  // Failed Jobs Service
  fetchPayoutFailedJobOpen({ commit }) {
    commit('PAYOUT_FAILED_JOB_SET_OPEN_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/failed-job/open`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { failedJobs } = response;
          commit('PAYOUT_FAILED_JOB_SET_OPEN_LOADING', false);
          commit('PAYOUT_FAILED_JOB_SET_OPEN', failedJobs);
        });
      })
      .catch((error) => {
        commit('PAYOUT_FAILED_JOB_SET_OPEN_LOADING', false);
        commit('PAYOUT_FAILED_JOB_SET_OPEN', []);

        return Promise.reject(error);
      });
  },
  fetchPayoutFailedJobResolved({ commit }) {
    commit('PAYOUT_FAILED_JOB_SET_RESOLVED_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/failed-job/resolved`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { failedJobs } = response;
          commit('PAYOUT_FAILED_JOB_SET_RESOLVED_LOADING', false);
          commit('PAYOUT_FAILED_JOB_SET_RESOLVED', failedJobs);
        });
      })
      .catch((error) => {
        commit('PAYOUT_FAILED_JOB_SET_RESOLVED_LOADING', false);
        commit('PAYOUT_FAILED_JOB_SET_RESOLVED', []);

        return Promise.reject(error);
      });
  },
  // eslint-disable-next-line no-unused-vars
  callPayoutFailedJobResolve({ dispatch }, params) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/failed-job/resolve`, {
      id: params.id,
      resolved: params.resolved,
    });
  },
  // Generic method to fetch all required data.
  fetchPayoutAll({ dispatch }, params) {
    dispatch('fetchPayoutApprovalPending', params);
    dispatch('fetchPayoutHolderEnrichmentPending', params);
    dispatch('fetchPayoutHolderApprovalPending', params);
    dispatch('fetchPayoutBankTransferApprovalPending', params);
    dispatch('fetchPayoutFinalCheckApprovalPending', params);
  },
  // eslint-disable-next-line no-unused-vars
  fetchTaxtraitAllDownloadCsv() {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/tax-trait/export/csv`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
  // Method to recreate payout documents
  recreatePdfDocument({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/pdf/recreate`, payload)
      .then(data => data).catch(error => Promise.reject(error));
  },
  // eslint-disable-next-line no-unused-vars
  patDocumentsPushLatestState({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/maintenance/sendPdfCreatedEvents`, payload)
      .then(data => data).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
};

const payout = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default payout;



// WEBPACK FOOTER //
// ./src/store/payout/payout.js